<template>
  <div>
    <item
      v-for="notification in notifications" :key="notification.id"
      :notification="notification"
      :collapsed="collapsed"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Item from '@/components/notifications/settings/Item';

export default {
  name: 'List',
  props: {
    notifications: {
      type: Array,
      required: true,
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  components: {
    Item,
  },
};
</script>

<style scoped>

</style>
